import { styled } from '@mui/material';
import * as Styled from '../styles';

export * from '../styles';

export const AuthOutletContainer = styled(Styled.OutletContainer)`
  width: 100vw;
`;
